import { DossierSearchCriteria, DossierSearchType } from '@app/pcs/models';
import {
  AGENCY_INVOLVEMENT,
  INVOLVED_AGENCY_TRAFFIC_LIGHT_PAIRS,
  TRAIN_TYPES
} from '@app/pcs/reducer/advanced-search/search-form';
import { hasValue } from '@util';
import * as R from 'ramda';

export interface AdvancedSearchAdditionalFields {
  [key: string]: boolean;
}

export const addExclusiveFields = (activeFields: AdvancedSearchAdditionalFields): AdvancedSearchAdditionalFields =>
  R.mergeDeepLeft(activeFields, {
    involvedAgencies: false,
    progressStatuses: false,
    involvedAgencyTrafficLightPairs: false
  });

export const omitFieldsBySearchType = (searchType: DossierSearchType, additionalFields: AdvancedSearchAdditionalFields): AdvancedSearchAdditionalFields =>
  R.cond([
    [(searchType, _) => R.equals(searchType, DossierSearchType.CARRY_FORWARD), (_, additionalFields) => R.omit([TRAIN_TYPES], additionalFields)],
    [(searchType, _) => R.equals(searchType, DossierSearchType.BULK_RU_APPOINTMENT), (_, additionalFields) => R.omit([TRAIN_TYPES, AGENCY_INVOLVEMENT], additionalFields)],
    [R.T, R.always(additionalFields)]
  ])(searchType, additionalFields);

export const omitMutuallyExclusiveFields = (activeFields: AdvancedSearchAdditionalFields): AdvancedSearchAdditionalFields =>
  R.cond([
    [R.anyPass([R.propEq('involvedAgencies', true), R.propEq('progressStatuses', true)]), R.omit([INVOLVED_AGENCY_TRAFFIC_LIGHT_PAIRS])],
    [R.propEq(INVOLVED_AGENCY_TRAFFIC_LIGHT_PAIRS, true), R.omit(['involvedAgencies', 'progressStatuses'])],
    [R.T, R.identity]
  ])(activeFields);

export const omitFieldsUsedInGroup = (activeFields: AdvancedSearchAdditionalFields): AdvancedSearchAdditionalFields =>
  R.omit(['appointedAsRu', 'imPermanentAcceptance'], activeFields);

export const getAdvancedSearchAdditionalFields = (searchCriteria: DossierSearchCriteria, dossierSearchType: DossierSearchType): AdvancedSearchAdditionalFields => ({
  dossierName: hasValue(searchCriteria.dossierName),
  dossierRoute: hasValue(searchCriteria.dossierRoute),
  cataloguePathNumber: hasValue(searchCriteria.cataloguePathNumber),
  trainNumber: hasValue(searchCriteria.trainNumber),
  labels: hasValue(searchCriteria.labels),
  trainTypes: hasValue(searchCriteria.trainTypes),
  dossierType: hasValue(searchCriteria.dossierType),
  operationPoints: hasValue(searchCriteria.operationPoints),
  rfcCorridor: hasValue(searchCriteria.rfcCorridor),
  phaseGroup: hasValue(searchCriteria.phaseGroup),
  agencyInvolvement: dossierSearchType !== DossierSearchType.BULK_RU_APPOINTMENT_PROCESSING && hasValue(searchCriteria.agencyInvolvement),
  involvedAgencies: hasValue(searchCriteria.involvedAgencies),
  myProgressStatuses: dossierSearchType !== DossierSearchType.BULK_PERMANENT_ACCEPTANCE && hasValue(searchCriteria.myProgressStatuses),
  progressStatuses: hasValue(searchCriteria.progressStatuses),
  involvedAgencyTrafficLightPairs: hasValue(searchCriteria.involvedAgencyTrafficLightPairs),
  appointedAsRu: dossierSearchType !== DossierSearchType.BULK_RU_APPOINTMENT_PROCESSING && hasValue(searchCriteria.appointedAsRu),
  imPermanentAcceptance: hasValue(searchCriteria.imPermanentAcceptance)
});
